import styled, { css } from "styled-components";
import { getColor, getColorWithAlpha, responsive } from "~/helpers/style";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const CheckboxesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

export const CheckboxContainer = styled.button<{
  checked: boolean;
  isDisabled?: boolean;
}>`
  display: flex;
  height: 76px;
  align-items: center;
  cursor: pointer;
  border-radius: 8px;
  background-color: transparent;
  opacity: ${(props) => (props.isDisabled ? 0.4 : 1)};
  width: 100%;
  padding: 12px 4px 12px 16px;
  border: 1px solid
    ${(props) =>
      props.checked ? getColor("primary") : getColorWithAlpha("primary", 0.1)};

  ${responsive("tablet")} {
    width: 49%;
  }

  ${responsive("mobileL")} {
    padding: 10px 76px 10px 15px;
  }

  & .onboarding-categories-checkbox {
    background: none;
    margin: 0;
    padding: 0;

    > span {
      color: ${getColor("text")};
      font-family: Inter, sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: ${(props) => (props.checked ? 600 : 500)};
      line-height: 25.48px;
    }
  }
`;

export const CheckboxText = styled.p<{ checked: boolean }>`
  margin: 0;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  background-color: transparent;
  color: ${getColor("text")};
  line-height: 25.48px;
  font-family: Inter, sans-serif;

  ${(props) =>
    props.checked
      ? css`
          font-weight: 600;
        `
      : ""}

  ${responsive("tablet")} {
    line-height: 182%;
  }
`;

export const PickUpContainer = styled.div`
  height: 76px;
  width: 100%;

  ${responsive("tablet")} {
    width: 49%;
  }
`;
